module.exports = __webpack_public_path__ + "img/制御工学4_4.9ef014b3.png";